/*
 *  -----------------------------------------------------------------------
 *    <copyright file="status-label/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

export interface StatusLabelProps {
    text: string;
    status: string;
}

export enum LabelStatuses {
    success = 'success',
    failure = 'failure',
    notice = 'notice',
    default = 'default',
}
